module.exports = __webpack_public_path__ + "img/barGraph.df6b646f.svg";